export const mainTextColor = '#ffffff'